import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { transformResponseHandler } from "../../utils/transformResponseHandler"

export const customerApi = createApi({
  reducerPath: "customerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_ROUTE}`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.posData?.token
      if (token) {
        headers.set("Authorization", token)
      }
      return headers
    },
  }),
  tagTypes: ["Customers", "Orders", "Vendors", "Categories", "FoodItems", "ThemeSetting", "Dashboard"],
  endpoints: (builder) => ({
    getCustomerByPhone: builder.mutation({
      query: (customerNumber) => ({
        url: `/customer/search-by-phone`,
        method: "GET",
        params: { ...customerNumber },
      }),
      // transformErrorResponse: (error) => transformResponseHandler(error),
    }),
    addUpdateCustomer: builder.mutation({
      query: ({ body, id }) => ({
        url: "/customer",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Customers"],
      transformResponse: (resp) => transformResponseHandler(resp),
      transformErrorResponse: (error) => transformResponseHandler(error),
    }),
    addOrder: builder.mutation({
      query: (orderData) => ({
        url: "/order",
        method: "POST",
        body: orderData,
      }),
      invalidatesTags: ["Orders"],
      transformResponse: (resp) => transformResponseHandler(resp),
      transformErrorResponse: (error) => transformResponseHandler(error),
    }),
    // POS endpoints
    getVendorTable: builder.query({
      query: () => ({
        url: "/pos/vendor-table",
        method: "GET",
      }),
      providesTags: ["Vendors"],
      transformErrorResponse: (error) => transformResponseHandler(error),
    }),
    getAvailableTable: builder.query({
      query: () => ({
        url: `/pos/vendor-table/available`,
        method: "GET",
      }),
      // providesTags: ["Vendors"],
      transformErrorResponse: (error) => transformResponseHandler(error),
    }),
    checkAvailableTable: builder.query({
      query: ({ booking_date, booking_time, table_id, end_time }) => {
        let url = `/pos/vendor-table/check-table?booking_date=${booking_date}&booking_time=${booking_time}&table_id=${table_id}`;
        if (end_time) {
          url += `&end_time=${end_time}`;
        }
        return {
          url,
          method: "GET",
        };
      },
      // providesTags: ["Vendors"],
      transformErrorResponse: (error) => transformResponseHandler(error),
    }),
    getCategories: builder.query({
      query: () => ({
        url: "/pos/categories?perPage=all",
        method: "GET",
      }),
      providesTags: ["Categories"],
      transformErrorResponse: (error) => transformResponseHandler(error),
    }),
    getFoodItems: builder.query({
      // accept an object with optional category & search
      query: ({ category, search, data } = {}) => {
        const params = {}
        if (category != null) params.category = category
        if (search) params.search = search
        if (data) params.data = data
        return {
          url: '/pos/food-items',
          method: 'GET',
          params,      // fetchBaseQuery will serialize this into ?category=…&search=…
        }
      },
      providesTags: ['FoodItems'],
      transformErrorResponse: (err) => transformResponseHandler(err),
    }),
    getThemes: builder.query({
      query: () => ({
        url: '/get-themes',
        method: 'GET',
      }),
      providesTags: ['ThemeSetting'],
      //   transformResponse: (resp) => transformResponseHandler(resp),
      transformErrorResponse: (error) => transformResponseHandler(error),
    }),
    getSummary: builder.query({
      query: () => ({
        url: '/pos/master',
        method: 'GET',
      }),
      //   transformResponse: (resp) => transformResponseHandler(resp),
      transformErrorResponse: (error) => transformResponseHandler(error),
    }),
    getDashboardStats: builder.query({
      query: (params) => ({
        url: '/pos/dashboard/stats',
        method: 'GET',
        params: params
      }),
      providesTags: ['Dashboard'],
      transformErrorResponse: (error) => transformResponseHandler(error),
    }),
    getDashboardCharts: builder.query({
      query: (params) => ({
        url: '/pos/dashboard/charts',
        method: 'GET',
        params: params
      }),
      providesTags: ['Dashboard'],
      transformErrorResponse: (error) => transformResponseHandler(error),
    }),
    findDeliveryFee: builder.mutation({
      query: (payload) => ({
        url: "/pos/find-delivery-fee",
        method: "POST",
        body: payload
      }),
      transformResponse: (resp) => transformResponseHandler(resp, false),
      transformErrorResponse: (error) => transformResponseHandler(error, false),
    })
  }),
})

export const {
  useGetCustomerByPhoneMutation,
  useAddUpdateCustomerMutation,
  useAddOrderMutation,
  useGetVendorTableQuery,
  useGetAvailableTableQuery,
  useCheckAvailableTableQuery,
  useGetCategoriesQuery,
  useGetFoodItemsQuery,
  useGetThemesQuery,
  useGetSummaryQuery,
  useGetDashboardStatsQuery,
  useGetDashboardChartsQuery,
  useFindDeliveryFeeMutation,
} = customerApi